import { Directive, TemplateRef } from "@angular/core";

/**
 * Directive to mark a template as the mobile card renderer for a row.
 * Usage: <ng-template appTableResponsiveCardTemplate let-row>
 *   ... card content for the row ...
 * </ng-template>
 */
@Directive({
  selector: "[appTableResponsiveCardTemplate]",
  standalone: true,
})
export class TableResponsiveCardTemplateDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
